import { render, staticRenderFns } from "./se2a-final-project-report-widget.vue?vue&type=template&id=57f49528&scoped=true"
import script from "./se2a-final-project-report-widget.vue?vue&type=script&lang=js"
export * from "./se2a-final-project-report-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f49528",
  null
  
)

export default component.exports